import * as React from 'react'
import { AreaStack } from '@vx/shape'
import { scaleTime, scaleLinear, scaleOrdinal } from '@vx/scale'
import { extent } from 'd3-array'
import { getMax } from '../GraphStackedBar'
import * as colors from 'styles/colors-export.css'
import { AxisBottom, AxisRight } from '@vx/axis'
import { withTooltip } from '@vx/tooltip'
import { GraphTooltip } from '../GraphTooltip'
import LinedTable from 'components/Tables/LinedTable'
import { localPoint } from '@vx/event'
import { GridRows } from '@vx/grid'
import * as s from './GraphStackedAreas.scss'

const x = d => new Date(d.date)

export const GraphStackedAreasComponent = ({
  label,
  data,
  keys,
  width,
  height,
  tooltipOpen,
  tooltipLeft,
  tooltipTop,
  tooltipData,
  hideTooltip,
  showTooltip,
  onClick,
}) => {
  const margin = {
    top: 0,
    bottom: 30,
    left: 0,
    right: 40,
  }
  const yMax = height - margin.top - margin.bottom
  const xMax = width - margin.left - margin.right

  const xScale = scaleTime({
    range: [0, xMax],
    domain: extent(data, x),
  })
  const yScale = scaleLinear({
    range: [yMax, 0],
    domain: [0, getMax(data, keys)],
  })
  // const opacityScale = scaleLinear({
  //   range: [.3, 1],
  //   domain: [0, keys.length]
  // })
  const zScale = scaleOrdinal({
    domain: keys,
    range: [
      colors.graph1,
      colors.graph2,
      colors.graph3,
      colors.graph4,
      colors.graph5,
      colors.graph6,
      colors.graph7,
      colors.graph8,
    ],
  })

  return (
    <div>
      <svg width={width} height={height} className={s.graph}>
        <AreaStack
          reverse
          top={margin.top}
          left={margin.left}
          keys={keys}
          data={data}
          x={d => xScale(x(d.data))}
          y0={d => yScale(d[0])}
          y1={d => yScale(d[1])}
          strokeWidth={0}
          fill={d => zScale(d.series.key)}
          fillOpacity={d => (tooltipData && d.series.key === tooltipData.key ? 1 : 0.8)}
          onClick={data => event => {
            if (onClick) {
              onClick(data)
            }
          }}
          onMouseLeave={data => event => hideTooltip()}
          onMouseMove={data => event => {
            const coords = localPoint(event.target.ownerSVGElement, event)
            const key = data.series.key

            showTooltip({
              tooltipLeft: coords.x,
              tooltipTop: coords.y,
              tooltipData: {
                key,
              },
            })
          }}
        />
        <GridRows
          top={margin.top}
          scale={yScale}
          width={xMax}
          height={yMax}
          stroke="rgba(0,0,0,0.1)"
        />
        <AxisBottom
          scale={xScale}
          top={yMax + margin.top}
          numTicks={5}
          stroke="rgba(0,0,0,0.1)"
          tickStroke="rgba(0,0,0,0.1)"
          tickLabelProps={(value, index) => ({
            fontSize: 10,
            textAnchor: 'middle',
          })}
        />
        <AxisRight hideAxisLine hideTicks scale={yScale} numTicks={6} left={xMax} top={0} />
      </svg>
      {tooltipOpen && (
        <GraphTooltip top={tooltipTop} left={tooltipLeft}>
          <LinedTable>
            <div>
              <div>{label || 'Number'}:</div>
              <div>{tooltipData.key}</div>
            </div>
          </LinedTable>
        </GraphTooltip>
      )}
    </div>
  )
}

export const GraphStackedAreas = withTooltip(GraphStackedAreasComponent)



// WEBPACK FOOTER //
// src/features/CallAnalytics/GraphStackedAreas/GraphStackedAreas.tsx